import React, { useState, useEffect, useContext } from "react";
import { getClientbyLcationAsync } from "../../../api/Dashboard";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { simpleMessage } from "../../../helpers/Helpers";
import BarList from "../../../components/ui/BarList";

const ClientsByLocation = ({ selectedSucursal }) => {
  const [datos, setDatos] = useState([]);

  const { setIsLoading, setIsUnautorized } = useContext(DataContext);

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getClientbyLcationAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setDatos(result.data.result || []);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSucursal]);

  // El endpoint devuelve `location` (nombre del municipio) y `abrev`. Se usa el
  // nombre completo: en una lista horizontal hay espacio de sobra y la
  // abreviatura obligaba a adivinar de que municipio se trata.
  return (
    <BarList
      items={datos.map((item) => ({
        label: item.location,
        value: item.contador,
      }))}
    />
  );
};

export default ClientsByLocation;
